module.exports = __webpack_public_path__ + "static/media/S (61).0e92efe1.jpg";